import Parent from '../views/Parent.vue';

import ForceActiveMerchant from '../views/force-active-management/ForceActiveMerchant.vue';
import ApprovalForceActiveMerchant from '../views/force-active-management/ApprovalForceActiveMerchant.vue';

// eslint-disable-next-line import/no-cycle
import { setBreadcrumb } from './index';

const forceActiveManagementRoute = {
  path: '/force-active-management',
  name: 'Fore Active',
  meta: {
    title: 'BNI QRIS - Fore Active',
    appBarTitle: 'Fore Active',
  },
  component: Parent,
  children: [
    {
      path: '/force-active-merchant',
      meta: {
        title: 'BNI QRIS - Force Active Merchant',
        appBarTitle: 'Force Active Merchant',
        breadcrumbs: () => [
          setBreadcrumb(
            'Menu Pengajuan Merchant',
            '/force-active-merchant',
            true
          ),
          setBreadcrumb('Force Active Merchant', '/force-active-merchant'),
        ],
      },
      component: ForceActiveMerchant,
      name: 'ForceActiveMerchant',
    },
    {
      path: '/approval-force-active-merchant',
      meta: {
        title: 'BNI QRIS - Approval Force Active Merchant',
        appBarTitle: 'Approval Force Active Merchant',
        breadcrumbs: () => [
          setBreadcrumb(
            'Menu Pengajuan Merchant',
            '/approval-force-active-merchant',
            true
          ),
          setBreadcrumb(
            'Approval Force Active Merchant',
            '/approval-force-active-merchant'
          ),
        ],
      },
      component: ApprovalForceActiveMerchant,
      name: 'ApprovalForceActiveMerchant',
    },
  ],
};

export default forceActiveManagementRoute;
